import { takeEvery, fork, put, all, call } from 'redux-saga/effects';
import { UPDATE_DEALER_CREDENTIALS, BULK_UPDATE_DEALER_CREDENTIALS } from './actionTypes';
import { updateDealerCredentialsSuccessful, updateDealerCredentialsFailed, updateDealerCredentials, bulkUpdateDealerCredentialsSuccessful, bulkUpdateDealerCredentialsFailed } from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* editDealerCredentials({ payload: { data } }) {
    try {
        const response = yield call(addData, '/updateDealerCredentials', data);
        if (response.Status) {
            yield put(updateDealerCredentialsSuccessful(response.Message));
        }
        else {
            yield put(updateDealerCredentialsFailed(response.Message));
        }
    } catch (error) {
        yield put(updateDealerCredentialsFailed(error));
    }
}

function* editBulkDealerCredentials({ payload: { data } }) {
    try {
        const response = yield call(addData, '/bulkupdatePasswordForTMobile', data);
        if (response.Status) {
            yield put(bulkUpdateDealerCredentialsSuccessful(response.Message));
            // yield put(updateDealerCredentials());
        }
        else {
            yield put(bulkUpdateDealerCredentialsFailed(response.Message));
        }
    } catch (error) {
        yield put(bulkUpdateDealerCredentialsFailed(error));
    }
}

export function* watchEditDealerCredentials() {
    yield takeEvery(UPDATE_DEALER_CREDENTIALS, editDealerCredentials)
    yield takeEvery(BULK_UPDATE_DEALER_CREDENTIALS, editBulkDealerCredentials)

}

function* addDealerCredentialsSaga() {
    yield all([fork(watchEditDealerCredentials),]);

}

export default addDealerCredentialsSaga;

